<template>
    <div>
    <hr>
    <footer>
     <div class="footerContainer container-fluid">

        <div class="copy">
            Gabriel de Oliveira | Copyright © 2024  
        </div>

            <div class="redes">

               <a :href="whatsapp" target="_blank"><button class="btnRedes">Whatsapp</button></a>

               <a :href="github"  target="_blank"><button class="btnRedes">Github</button></a>

               <a :href="linkedin" target="_blank"><button class="btnRedes">Linkedin</button></a>
            </div>


        <div class="download">
            <a href="#topo">Voltar ao topo</a>
        </div>

     </div>
    </footer>
</div>
  </template>

<script>
export default {  
    name:'footerVue',
    data(){
        return{
            CV:'./assets/GabrielOliveira.pdf',
            whatsapp:'https://api.whatsapp.com/send?phone=5512997068967',
            github:'https://github.com/Zokaaah',
            linkedin:'https://www.linkedin.com/in/gabriel-oliveira-silva-471b23194/',
        }
    }

}
</script>

<style scoped>

a{
    text-decoration: none;
    color: #2c3e50;
}
hr{
    width: 80%;
    text-align: center;
    margin: 0 auto;
}
footer {
  padding: 20px 0;
  text-align: center;
}

.footerContainer{
    padding: 2%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    justify-items: center;
    font-family: 'Montserrat-VariableFont_wght'!important;



}

h2{
    margin-bottom: 3%;
}
a{
  font-family: 'Montserrat-VariableFont_wght'!important;

}

@font-face {
    font-family: Montserrat-VariableFont_wght;
    src: url('~@/assets/Montserrat-VariableFont_wght.ttf');
}

.btnRedes{
    color: #4453E1;
    background-color: #fff;
    border-radius: 7px;
    padding: 12px;
    width: 130px;
    border: solid 1px #4453E1;
    cursor: pointer;
    transition: all 0.3s;
    -webkit-transition: width 1s;
    transition: width 1s;
    font-family: 'Montserrat-VariableFont_wght'!important;
    -webkit-transition: all .5s;
    -moz-transition: all .5s;
    transition: all .5s;
    float: left;
    margin-left: 10px;
}
.btnRedes:hover{
    background-color: #4453E1;
    color: #fff;
    border: solid 1px #4453E1;
    transform: scale(1.1);

 }

 .copy{
    width: 30%;

 }

 .redes{
    width: 40%;
    display: flex;
    justify-content: center;

 }
 .download{
    width: 30%;


 }

 @media only screen and (max-width: 869px)  {

    a{
    text-decoration: none;
    color: #2c3e50;
}
hr{
    width: 80%;
    text-align: center;
    margin: 0 auto;
}
footer {
  padding: 20px 0;
  text-align: center;
}


.copy{
    width: 100% !important;
}

.redes{
    width: 100% !important;
}
.footerContainer{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    justify-items: center;
}

h2{
    margin-bottom: 3%;
}
.redes{
    display: flex;
    flex-direction: row;
    justify-content: center !important;
    align-content: center;
    margin-top: 3%;
    margin-bottom: 3%;
}

.btnRedes{
    color: #4453E1;
    background-color: #fff;
    border-radius: 7px;
    font-size: 12px;
    padding: 12px;
    width: 80px;
    border: solid 1px #4453E1;
    cursor: pointer;
    transition: all 0.3s;
    -webkit-transition: width 1s;
    transition: width 1s;

    -webkit-transition: all .5s;
    -moz-transition: all .5s;
    transition: all .5s;
    float: left;
    margin-left: 10px;
}
.btnRedes:hover{
    background-color: #4453E1;
    color: #fff;
    border: solid 1px #4453E1;
    transform: scale(1.1);

 }

 .download{
    display: none;
 }
 
}




</style>